<template>
	<div>
		<div class="wrapper1200" style="display: flex;margin-top: 20px;">
			<div class="classification">
				<div class="singleType" :class="typeIndex==0?'active':''" @click="switchType(0)">病例信息</div>
				<div class="singleType" :class="typeIndex==1?'active':''" @click="switchType(1)">历史病例</div>
			</div>
			<div class="diagnosis" v-if="typeIndex==0">
				<div class="crumbs">病例信息 > 病例信息</div>
				<div class="largeScreen">
					<div class="theShowerheadIsVery">
						<img src="../assets/image/backgroundOfTheCase.png" alt="" class="diagnosticBackground" />
						<div class="westernSydney">
							<div class="information">
								<img :src="information.avatar==''?'../assets/logo.png':information.avatar" alt=""
									class="headPortrait" />
								<div class="youBut">
									<div class="ohYouEat">
										{{information.realName}}<span>{{information.gender==0?'女':'男'}} |
											{{information.age}}岁</span>
									</div>
									<div class="flex address">
										<img src="../assets/icon/smallPhone.png" alt="" />
										<div>{{information.phone}}</div>
									</div>
									<div class="flex address">
										<img src="../assets/icon/address.png" alt="" />
										<div>{{information.address}}{{information.addressDetails}}</div>
									</div>
								</div>
							</div>
							<div class="whether">
								<div>是否确诊</div>
								<img src="../assets/icon/choice.png" alt="" />
								<div>{{information.isDefinite==0?'否':'是'}}</div>
							</div>
						</div>
					</div>


					<div class="caseTitle">
						<div>既往史和其他病史</div>
						<img src="../assets/icon/diagonalLine.png" alt="" />
					</div>
					<div class="inputBox">
						<input type="text" placeholder="请输入既往史和其他病史内容" @keyup.enter="onEnter"
							v-model="medicalHistory" />
					</div>
					<div class="caseTitle">
						<div>过敏史(食物或者药品)</div>
						<img src="../assets/icon/diagonalLine.png" alt="" />
					</div>
					<div class="inputBox">
						<input type="text" placeholder="请输入过敏史(食物或者药品)内容" v-model="allergy" @keyup.enter="onEnter" />
					</div>
					<div class="addCase" @click="jumpTo">添加病例信息</div>
				</div>
			</div>


			<div class="diagnosis" v-if="typeIndex==1">
				<div class="heartache">
					<div class="crumbers">病例信息 > 历史病例</div>
					<div class="addCase" @click="jumpTo">+ 添加病例信息</div>
				</div>
				<div class="caseList" v-for="(item,index) in listOfCases" :key="index" @click="jumpDetails(item)">
					<div class="timeHead">
						<div>{{item.createTime}}</div>
						<img src="../assets/icon/deleteIcon.png" alt="" @click.stop="deleteContent(item)" />
					</div>
					<div class="diagnosticContent">
						{{item.suit}}
					</div>
					<div class='diagnosticPhotos' v-if="item.img!=''">
						<div>诊断照片</div>
						<img :src="item.img" alt="" />
					</div>
				</div>
				<div class="defaults" v-if="listOfCases==''">
					<el-empty description="暂无数据"></el-empty>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import {
		caseList,
		deleteCase,
		userInformation,
		newlyAddedCases,
		modifyUser
	} from "@/api/api.js"
	export default {
		data() {
			return {
				typeIndex: 0,
				listOfCases: '',
				information: '',
				medicalHistory: '',
				allergy: ''
			}
		},
		created() {
			this.historicalCases()
			this.personalInformation()
		},
		methods: {
			switchType(i) {
				this.typeIndex = i
			},
			onEnter() {
				modifyUser({
					medicalHistory: this.medicalHistory,
					allergy: this.allergy,
				}).then(res => {
					if (res.code == 200) {
						this.$message({
							message: res.msg,
							type: 'success'
						});
						// setTimeout(() => {
						// 	this.$router.push({
						// 		path: '/caseInformation'
						// 	})
						// }, 1000);
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			// 用户信息
			personalInformation() {
				userInformation().then(res => {
					this.information = res.data
					this.medicalHistory = res.data.medicalHistory
					this.allergy = res.data.allergy
				})
			},
			deleteContent(item) {
				this.$confirm('是否删除当前这条历史病例?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteCase({
						caseReportId: item.caseReportId
					}).then(res => {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						setTimeout(() => {
							this.historicalCases()
						}, 500);
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			jumpDetails(item) {
				this.$router.push({
					path: '/caseDetails',
					query: {
						id: item.caseReportId
					}
				})
			},
			historicalCases() {
				caseList().then(res => {
					this.listOfCases = res.rows
					console.log(res, '2222222');
				})
			},
			jumpTo() {
				this.$router.push({
					path: '/addCase'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.classification {
		.singleType {
			width: 202px;
			height: 50px;
			background: #F1F1F1;
			border-radius: 0px 0px 0px 0px;
			line-height: 50px;
			padding-left: 18px;
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			font-size: 15px;
			color: #333333;
		}

		.active {
			background: #D89A3A;
			color: #fff;
		}
	}

	.diagnosis {
		margin-left: 20px;
		padding-bottom: 132px;
		// position: relative;
		flex: 1;
		cursor: default;

		.crumbs {
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			font-size: 14px;
			color: #666666;
			margin-bottom: 20px;
		}
	}

	.heartache {
		display: flex;
		align-items: center;
		justify-content: space-between;

		.crumbers {
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			font-size: 14px;
			color: #666666;
		}

		.addCase {
			font-family: PingFang SC, PingFang SC;
			font-weight: bold;
			font-size: 16px;
			color: #D89A3A;
		}


	}

	.caseList {
		background: #FFFFFF;
		padding: 18px 22px;
		margin-top: 20px;

		.timeHead {
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 16px;
			color: #333333;

			img {
				width: 16px;
				height: 16px;
			}
		}

		.diagnosticContent {
			background: #F8F8F8;
			border-radius: 6px 6px 6px 6px;
			padding: 12px 20px;
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #666666;
			margin: 10px 0;
		}

		.diagnosticPhotos {
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #D89A3A;

			img {
				width: 60px;
				height: 60px;
			}
		}
	}

	.largeScreen {
		width: 800px;
		// height: 446px;
		background: #FFFFFF;
		padding: 0 80px;
		padding-top: 14px;
		padding-bottom: 58px;
		margin-top: 20px;

		.theShowerheadIsVery {

			width: 800px;
			height: 104px;
			position: relative;

			.diagnosticBackground {
				width: 800px;
				height: 104px;
			}

			.westernSydney {
				position: absolute;
				left: 20px;
				right: 20px;
				top: 16px;
				display: flex;

				// align-items: center;
				justify-content: space-between;

				.information {
					display: flex;
					align-items: center;

					.headPortrait {
						width: 50px;
						height: 50px;
						border-radius: 100%;
					}

					.youBut {
						margin-left: 20px;

						.ohYouEat {
							font-family: PingFang SC, PingFang SC;
							font-weight: bold;
							font-size: 16px;
							color: #5F3A1B;

							span {
								font-family: PingFang SC, PingFang SC;
								font-weight: 500;
								font-size: 13px;
								color: #936C4C;
								margin-left: 20px;
							}
						}

						.address {
							font-family: PingFang SC, PingFang SC;
							font-weight: 500;
							font-size: 12px;
							color: #936C4C;
							margin-top: 6px;

							img {
								width: 16px;
								height: 16px;
							}
						}
					}
				}

				.whether {
					width: 136px;
					height: 38px;
					background: rgba(255, 255, 255, 0.8);
					border-radius: 40px 40px 40px 40px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 13px;
					color: #333333;

					img {
						margin-left: 22px;
						width: 13px;
						height: 13px;
						margin-right: 5px;
					}
				}

			}
		}

		.caseTitle {
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #333333;
			position: relative;
			padding-top: 20px;


			img {
				position: absolute;
				bottom: 2px;
				left: 2px;
				width: 18px;
				height: 6.54px;
			}
		}

		.inputBox {
			padding-bottom: 6px;
			border-bottom: 1px solid #E6E6E6;
			padding-top: 12px;

			input:focus {
				outline: none;
				/* 取消轮廓 */
				border: none;
				/* 取消边框 */
				/* 其他样式属性根据需要设置为默认值或者移除 */
			}

			input {
				width: 100%;
				border: none;
			}
		}

		.addCase {
			width: 351px;
			height: 44px;
			background: linear-gradient(90deg, #ECBF85 0%, #D89A3A 100%);
			border-radius: 22px 22px 22px 22px;
			font-family: PingFang SC, PingFang SC;
			font-weight: bold;
			font-size: 16px;
			color: #FFFFFF;
			text-align: center;
			line-height: 44px;
			margin: 0 auto;
			margin-top: 60px;
		}

	}
</style>